import gql from 'graphql-tag';

export const CHECK_VO_SOS_DATA = gql`
  query CobaltIntelligenceCheckVoSosData($input: CheckVoSosDataInput!) {
    cobaltIntelligence {
      result: checkVoSosData(input: $input) {
        entity {
          hasData
          missingData
        }
        error
        success
      }
    }
  }
`;
